import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import AuthCallback from './pages/AuthCallback';
import Dashboard from './pages/Dashboard';
import ClubsPage from './pages/ClubsPage';
import ClubDetailPage from './pages/ClubDetailPage';
import InvestmentPage from './pages/InvestmentPage';
import ProfilePage from './pages/ProfilePage';
import MembershipPage from './pages/MembershipPage';
import WithdrawalsPage from './pages/WithdrawalsPage';
import KidsHub from './pages/KidsHub';
import SchoolPitchPage from './pages/SchoolPitchPage';
import SchoolPitchSlides from './pages/SchoolPitchSlides';
import LandingSlides from './pages/LandingSlides';
import AdminDashboard from './pages/AdminDashboard';
import AdvertisePage from './pages/AdvertisePage';
import SocialMediaAdKit from './pages/SocialMediaAdKit';
import LinkInBio from './pages/LinkInBio';
import SocialMediaHub from './pages/SocialMediaHub';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ProtectedRoute from './components/ProtectedRoute';
import AfricanMusicPlayer from './components/AfricanMusicPlayer';
import './App.css';

// Environment variables for payment integrations
const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

// Log configuration status (only in development)
if (process.env.NODE_ENV === 'development') {
  console.log('Stripe configured:', !!STRIPE_PUBLISHABLE_KEY);
}

function AppRouter() {
  const location = useLocation();
  
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } />
        <Route path="/clubs" element={
          <ProtectedRoute>
            <ClubsPage />
          </ProtectedRoute>
        } />
        <Route path="/clubs/:clubId" element={
          <ProtectedRoute>
            <ClubDetailPage />
          </ProtectedRoute>
        } />
        <Route path="/investments" element={
          <ProtectedRoute>
            <InvestmentPage />
          </ProtectedRoute>
        } />
        <Route path="/membership" element={
          <ProtectedRoute>
            <MembershipPage />
          </ProtectedRoute>
        } />
        <Route path="/withdrawals" element={
          <ProtectedRoute>
            <WithdrawalsPage />
          </ProtectedRoute>
        } />
        <Route path="/kids" element={
          <ProtectedRoute>
            <KidsHub />
          </ProtectedRoute>
        } />
        <Route path="/school-pitch" element={<SchoolPitchPage />} />
        <Route path="/school-pitch/slides" element={<SchoolPitchSlides />} />
        <Route path="/slides" element={<LandingSlides />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/profile" element={
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        } />
        <Route path="/advertise" element={<AdvertisePage />} />
        <Route path="/ads" element={<SocialMediaAdKit />} />
        <Route path="/links" element={<LinkInBio />} />
        <Route path="/social" element={<SocialMediaHub />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsOfServicePage />} />
      </Routes>
      <Toaster />
      <AfricanMusicPlayer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  );
}

export default App;